const path = (resource) => {
  if (!resource) resource = '';
  return { resource: 'api/plaid/' + resource };
};

export const createLinkToken = () => {
  return (dispatch, getState, api) => {
    return api.post(path('create_link_token'), {
      days_requested: 730,
    });
  };
};

export const setAccessToken = (publicToken) => {
  return (dispatch, getState, api) => {
    return api.post(path('set_access_token'), {
      public_token: publicToken,
    });
  };
};
